import { JWTUserData } from '@kit/supabase/types';
import { AppLogo } from '@kit/ui/patterns/app-logo';

import { SiteHeaderAccountSection } from './site-header-account-section';
import { SiteHeaderFrame } from './site-header-frame';
import { SiteNavigation } from './site-navigation';
import { WebsiteMobileHeaderActions } from './website-mobile-header-actions';

export function SiteHeader(props: { user?: JWTUserData | null }) {
  return (
    <SiteHeaderFrame>
      <a
        href="#site-content"
        className="bg-background text-foreground sr-only absolute top-2 left-2 rounded-md border p-3 focus:not-sr-only focus:z-50"
      >
        Skip to content
      </a>
      <div
        data-site-header-inner
        className="container mx-auto flex min-h-20 items-center gap-3 py-3 sm:gap-5"
      >
        <div data-site-header-logo className="order-1 shrink-0">
          <AppLogo label="Leagen home" className="w-[112px] sm:w-[124px]" />
        </div>
        <div
          data-site-header-navigation
          className="order-2 hidden flex-1 lg:block"
        >
          <SiteNavigation />
        </div>
        <div
          data-site-header-actions
          className="order-3 hidden items-center justify-end gap-2 lg:flex"
        >
          <SiteHeaderAccountSection user={props.user ?? null} />
        </div>
        <WebsiteMobileHeaderActions user={props.user ?? null} />
      </div>
    </SiteHeaderFrame>
  );
}
